import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { Navbar } from 'react-bootstrap';
import { ArrowLeft } from 'react-bootstrap-icons';

import AppIcon from '../../../assets/images/icon.png';
import { setBackStatus } from '../../../redux/common/actions';
import { setIsTransformationHappened } from '../../../redux/edit/actions';
import classes from './Header.module.css';

const mapStateToProps = (state) => {
    return {
        backStatus: state.common.backStatus,
        isBackBtnVisible: state.common.isBackBtnVisible,
        isMobileOS: state.common.isMobileOS,
        isMobileLandscapeView: state.common.isMobileLandscapeView,
        isTransformationHappened: state.edit.isTransformationHappened
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setBackStatus: (payload) => dispatch(setBackStatus(payload)),
        setIsTransformationHappened: (payload) => dispatch(setIsTransformationHappened(payload))
    }
}

const HeaderComponent = React.memo((props) => {
    const { isMobileOS, isMobileLandscapeView, setBackStatus, isBackBtnVisible,
        isTransformationHappened,
        setIsTransformationHappened
    } = props;

    const handleBack = () => {
        if (isTransformationHappened) {
            if (window.confirm('Changes made will not be saved. Are you sure you to proceed with back ?')) {
                setBackStatus(true);
                setIsTransformationHappened(false);
            } else {
                // Do nothing!
            }
        } else {
            setBackStatus(true);
        }
    }

    return (
        <div className={`${classes.headerContainer} ${isMobileOS && classes.mobileOSHeader} ${isMobileLandscapeView && classes.mobileLandscapeHeader}`}>
            {/* <img src={AppIcon} className={`${classes.logo} ${isMobileOS && classes.mobileOSLogo}`} /> */}
            {isBackBtnVisible && <ArrowLeft color='#ffffff' size={20} onClick={handleBack} />}
            <Navbar className={classes.headerMain}>
                <Navbar.Brand className={classes.headerBrand}>
                    <Link to="/">
                        {
                            props.page === "garage" ?
                                <img src={props.setting[props.page].logo} alt='MODIFAI' /> :
                                <img src={props.setting[props.page].logo} alt='MODIFAI' />
                        }
                    </Link>
                    {/* <span className={classes.appNameVersion}>(Beta)</span> */}
                </Navbar.Brand>
            </Navbar>
        </div>
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent);